export const COLOR_STATE_TAG = {
  LIVE: 'live',
  FINISHED: 'finished',
  CLOSED: 'closed',
  OUTBID: 'outbid',
  WIN: 'win'
}



// WEBPACK FOOTER //
// ./src/ui/tags/constants.js